import { BootAuthResponse } from "@/lib/types";
import { useLoginRedirection } from "@/hooks/useLoginRedirection";
import { useEffect } from "react";
import { SESSION_STORAGE_KEYS } from "@/lib/consts/sessionStorage";
import { saveUtms } from "@/lib/utils/utm";
import { LoggerEventNames } from "@/lib/consts/logger";
import { logoutGuard } from "@/lib/services/logoutGuard";
import coralogixRumService from "@/lib/services/coralogixRum";

export interface InitializeOptions {
    authBoot: BootAuthResponse;
}

const handleStandalone = () => {
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
    if (isStandalone) {
        sessionStorage.setItem(SESSION_STORAGE_KEYS.SOURCE, 'home screen bookmark');
    }
}

export const useLoginInitializer = (options: InitializeOptions) => {
    const { authBoot } = options;

    useLoginRedirection(authBoot);

    useEffect(() => {
        logoutGuard.reset();
        handleStandalone();

        if (authBoot.otpAccessToken) {
            saveUtms(authBoot.otpAccessToken).catch((error) => {
                coralogixRumService.sendErrorEvent(LoggerEventNames.LOGIN_ERROR, { error, message: 'Failed to save UTMs to backend' });
            });
        }
    }, []);
};